import { useRef } from "react";
import Select from "react-select";
import {
  getModelStatusDisplayValue,
  getModelStatuses,
  isModelStatus,
  ModelStatus,
} from "../../types/ModelStatus";

export { ModelStatusSelector, ModelStatusesSelector };

type Props = {
  selected: ModelStatus;
  onChange: (status: ModelStatus) => void;
};

const ModelStatusSelector = (props: Props) => {
  const displayedStatuses = getModelStatuses();
  return (
    <select
      value={props.selected}
      onChange={(e) => {
        if (!isModelStatus(e.target.value)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        props.onChange(e.target.value as ModelStatus);
      }}
    >
      {displayedStatuses.map((status) => (
        <option
          key={status}
          value={status}
          label={getModelStatusDisplayValue(status)}
        >
          {getModelStatusDisplayValue(status)}
        </option>
      ))}
    </select>
  );
};

type PluralProps = {
  selected: ModelStatus[] | undefined;
  onChange: (status: ModelStatus[]) => void;
};

const ModelStatusesSelector = (props: PluralProps) => {
  const optionsRef = useRef([
    { value: "AUTO", label: getModelStatusDisplayValue("AUTO") },
    { value: "MANUAL", label: getModelStatusDisplayValue("MANUAL") },
  ] as { value: string; label: string }[]).current;

  const selected = optionsRef.filter((o) =>
    props.selected?.includes(o.value as ModelStatus),
  );

  return (
    <Select
      value={selected}
      onChange={(x) => {
        props.onChange(x.map((x) => x.value as ModelStatus));
      }}
      isMulti
      name="Model Statuses"
      options={optionsRef}
      className="basic-multi-select"
      classNamePrefix="select"
    />
  );
};
